const awsExports = {
    Auth: {
        Cognito: {
            userPoolClientId: `${process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID}`,
            userPoolId: `${process.env.REACT_APP_COGNITO_USER_POOL_ID}`,
        }
    },
};

export default awsExports;
